import { render, staticRenderFns } from "./PageSignUp.vue?vue&type=template&id=397819e1&scoped=true&"
import script from "./PageSignUp.vue?vue&type=script&lang=ts&"
export * from "./PageSignUp.vue?vue&type=script&lang=ts&"
import style0 from "./PageSignUp.vue?vue&type=style&index=0&id=397819e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397819e1",
  null
  
)

export default component.exports